import { PackagesService } from '@/backend/market'
import { LivePackageRepository } from '../../domain/repositories/LivePackageRepository'
import type { LivePackageFilterEntity } from '../../domain/entities/LivePackageFilterEntity'
import { LivePackageFilterModel } from '../models/LivePackageFilterModel'
import { LivePackageResponseModel } from '../models/LivePackageResponseModel'
import { LivePackageStreamV2ResponseModel } from '../models/LivePackageStreamV2ResponseModel'
import type { GetPackagesCountByStatusAdminResponse } from '@/backend/market'

export class LivePackageRepositoryImpl implements LivePackageRepository {
  async getLivePackage(
    filterData: LivePackageFilterEntity
  ): Promise<LivePackageResponseModel | { error: true }> {
    const filterModel = new LivePackageFilterModel(filterData)
    try {
      const response = await PackagesService.getStreamingPackagesAdmin(filterModel)
      const livePackageResponseModel = new LivePackageResponseModel(response)

      return livePackageResponseModel
    } catch {
      return { error: true }
    }
  }
  async getLivePackageStreamV2(
    filterData: LivePackageFilterEntity
  ): Promise<LivePackageStreamV2ResponseModel | { error: true }> {
    try {
      const filterModel = new LivePackageFilterModel(filterData)
      const response = await PackagesService.getStreamingPackagesV2Admin({
        ...filterModel,
        // Ensure proper mapping if names differ, but model has matched names for stream V2
        // V2 stream expects: cursor, limit, packageStatuses, regionIds, fromDate, toDate
      })
      return new LivePackageStreamV2ResponseModel(response)
    } catch (e) {
      return { error: true }
    }
  }

  async getPackagesCountByStatus(
    filterData: LivePackageFilterEntity
  ): Promise<GetPackagesCountByStatusAdminResponse | { error: true }> {
    try {
      const filterModel = new LivePackageFilterModel(filterData)
      return await PackagesService.getPackagesCountByStatusAdmin({
        statuses: filterModel.packageStatuses,
        regionIds: filterModel.regionIds,
        fromDate: filterModel.fromDate,
        toDate: filterModel.toDate
      })
    } catch {
      return { error: true }
    }
  }

  async watchPackage(packageId: string): Promise<{ success: true } | { error: true }> {
    try {
      await PackagesService.postPackageTrackingAdmin({ id: packageId })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
